<template>
  <section class="info">
    <div class="container">
      <a-typography-title :level="1">
        <span>东数西算</span>
        <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">，</template>
        <br v-else />
        大幅降低企业数字化运营成本
      </a-typography-title>
      <a-row>
        <a-col :span="24"
               :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.SM)?1:2">
          <a-typography-paragraph>
            <span>2021年，我国启动全国一体化算力网络国家枢纽节点建设，加快推进“东数西算”工程，</span>
            <br v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">
            <span>旨在利用西部的气候、土地、电力资源优势充分节省数据计算的成本，争取于2025年底将超大型数据中心PUE降到1.3以下。</span>
          </a-typography-paragraph>
          <a-typography-title :level="5">
            为了满足数据备份、数据容灾、降低数据存储成本等需要，
            企业常常需要对数据进行复制、备份、迁移，因此数据迁移需求与场景激增。
          </a-typography-title>
        </a-col>
        <a-col :span="24"
               :order="$Store.Public().isGridMatch('>=',$Enum.GridEnum.SM)?2:1">
          <PlanInfoMap />
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import PlanInfoMap from '@template/page/planMigrate/component/planInfoMap.vue';

export default {
  name: 'plan_info',
  components: {
    PlanInfoMap
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planMigrate/';

.info {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

h5.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_12, @text, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

@media screen and (max-width: -1px+@grid_md) {
  .info {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text_mo+@line_mo, @color_12, @text_mo, true);
  }
  
  div.ant-typography {
    margin: 0;
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
}
</style>